import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/constants';
// Ressources
// Styles
import styles from './users-list-style';
import { UserList } from '../../../redux/reducers/api-types';
import { HeadCell } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';

interface RidersListProps extends WithTranslation, WithStyles, RouteComponentProps {}

class RidersListPage extends React.Component<RidersListProps> {
    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { idSearch: 'search[id]', sortable: true }),
            { id: 'firstname', idSearch: 'search[firstname]', label: t('common:form.firstname') },
            { id: 'lastname', idSearch: 'search[lastname]', label: t('common:form.lastname') },
            createCell(t, Cell.EMAIL, { idSearch: 'search[email]' }),
            createCell(t, Cell.PHONE_NUMBER, { id: 'phone', idSearch: 'search[phone]' }),
            createCell(t, Cell.COMPANY, {
                formatCell: (row: UserList) => {
                    return row?.company?.name;
                },
            }),
        ];
        return headers;
    };

    render() {
        const { t } = this.props;

        return (
            <App
                disableBreadcrumb
                header={{
                    title: t('title'),
                    subtitle: t('description'),
                }}
            >
                <EnhancedTable headers={this.headerBuilder()} type={tableRequestPoints.USERS} />
            </App>
        );
    }
}

export default withStyles(styles)(withTranslation(['rider', 'common'])(RidersListPage));
